'use client';

import React from 'react';
import { AuthenticationStep } from 'components/AuthenticationStep/AuthenticationStep';
import BrandPageShell from '@/components/BrandPageShell/BrandPageShell';

const RegisterPage = () => {
  return (
    <BrandPageShell
      title="Create your Razee account"
      subtitle="Start inside the app with the same brand, tone, and guided setup flow as Razee Web."
      contentMaxWidth={520}
    >
      <AuthenticationStep isRegistration />
    </BrandPageShell>
  );
};

export default RegisterPage;
